import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '../checkbox/Checkbox';
var TreeSelectAll = function TreeSelectAll(props) {
  var isDisabled = props.isDisabled,
    isChecked = props.isChecked,
    isEnabled = props.isEnabled,
    isIndeterminate = props.isIndeterminate,
    onSelect = props.onSelect;
  var handleSelectAll = function handleSelectAll(event) {
    return onSelect(event.target.checked, isIndeterminate);
  };
  return isEnabled ? /*#__PURE__*/React.createElement("div", {
    className: "TreeSelectAll display-flex align-items-center"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: isChecked,
    onClick: handleSelectAll,
    disabled: isDisabled,
    indeterminate: isIndeterminate,
    className: "margin-top--1"
  })) : null;
};
TreeSelectAll.displayName = 'TreeSelectAll';
TreeSelectAll.defaultProps = {
  isChecked: false,
  isEnabled: true,
  isIndeterminate: false,
  hasSearchResults: false,
  onChange: function onChange() {}
};
TreeSelectAll.propTypes = {
  value: PropTypes.string,
  onSelect: PropTypes.func,
  isChecked: PropTypes.bool,
  isEnabled: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isIndeterminate: PropTypes.bool,
  hasSearchResults: PropTypes.bool,
  className: PropTypes.string
};
export default TreeSelectAll;